<template>
  <div class="help">
    <div class="help__body" :class="className">
      <div class="help__image" v-if="screen_composition.form_info_image">
        <S3image
          :url="screen_composition.form_info_image"
          width="475"
          height="490"
        />
      </div>
      <div class="help__contents" v-if="screen_composition.form_info_text">
        <div class="help__form_info_text" v-html="screen_composition.form_info_text"></div>
        <!--
        <div class="help__form_info_contents">
          <h2 class="help__form_info_title">見出しテキスト</h2>
          <table class="help__info-table">
            <tr>
              <th>講演テーマ</th>
              <td>
                ひかりクラウド電話 for Webex Callingを基礎から学ぶシリーズ(全3回)～第3回 導入フロー・導入前準備とよくある注意点～
                <p class="help__note">※第1～3回と内容が続いているわけではございませんので、前回ご参加できなかった方もお気軽にお申し込みください</p>
              </td>
            </tr>
            <tr>
              <th>日時</th>
              <td>2025年1月17日(金) 14:00～15:00</td>
            </tr>
            <tr>
              <th>開催方式</th>
              <td>オンライン(無料)</td>
            </tr>
            <tr>
              <th>申し込み締切</th>
              <td>2025年1月16日(木) 12:00</td>
            </tr>
          </table>
          <div class="help__accordion-list">
            <details class="help__accordion">
              <summary>主な内容</summary>
              <div class="help__accordion-detail">
                <div class="help__accordion-sec">
                  <ul>
                    <li>リストが入ります</li>
                    <li>リストが入ります</li>
                    <li>リストが入ります</li>
                  </ul>
                </div>
                <div class="help__accordion-sec">
                  <ol>
                    <li>順序リストが入ります</li>
                    <li>順序リストが入ります</li>
                    <li>順序リストが入ります</li>
                  </ol>
                </div>
                <div class="help__accordion-sec">
                  <p class="help__note">※注釈テキストが入ります。注釈テキストが入ります。注釈テキストが入ります。注釈テキストが入ります。注釈テキストが入ります。</p>
                  <p class="help__note help__note--no-mark">注釈テキストが入ります。注釈テキストが入ります。注釈テキストが入ります。注釈テキストが入ります。注釈テキストが入ります。</p>
                </div>
              </div>
            </details>
            <details class="help__accordion">
              <summary>テキスト <small>サブテキスト</small></summary>
              <div class="help__accordion-detail">
                <div class="help__accordion-sec">
                  <ul>
                    <li>リストが入ります</li>
                    <li>リストが入ります</li>
                    <li>リストが入ります</li>
                  </ul>
                </div>
                <div class="help__accordion-sec">
                  <div class="help__card">
                    <div class="help__card-img"><img src="https://via.placeholder.com/187x219" alt="" width="187" height="219"></div>
                    <div class="help__card-contents">
                      <p class="help__card-title">東日本電信電話株式会社</p>
                      <p class="help__card-text">ビジネス開発本部 クラウド＆ネットワークビジネス部 コミュニケーションサービス担当</p>
                      <p class="help__card-name">佐藤 太一</p>
                    </div>
                  </div>
                </div>
              </div>
            </details>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/shared/sass/object/project/_help.scss";
import S3image from '@/components/img/S3image';
export default {
  props: [
          "type",
          "imgtype",
          "screen_composition"
          ],
  name: "help",
  components: {
    S3image,
  },
  computed: {
    imgName() {
      return this.imgtype ? `dummy475x490${this.type}` : "dummy475x490";
    },
    className() {
      return this.type ? `help__body--${this.type}` : "";
    },
  },
};
</script>
<style lang="scss" scoped>
.help__contents{
  width: 100%;
}
.help .help__form_info_title {
  color: $c-main;
  font-size: 2.4rem;
  line-height: 1.5;
  text-align: left;
  width: 100%;
  margin-bottom: 8px;
  &:not(:last-child) {
    margin-top: 32px;
  }
}
.help__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  &--default {
    .help__image {
      background-color: #f2f7fa;
    }
  }
}
.help__image {
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 30px;
  width: 100%;
  @media screen and (max-width: $sp_point) {
    border-radius: 10px;
    padding: 30px 50px;
  }
}
</style>
